'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$41() {
}
export { $c_Lmealorama_jsonCodecs$package$$anon$41 as $c_Lmealorama_jsonCodecs$package$$anon$41 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$41.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$41;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$41() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$41 as $h_Lmealorama_jsonCodecs$package$$anon$41 };
$h_Lmealorama_jsonCodecs$package$$anon$41.prototype = $p;
$p.Q = (function(x) {
  return (false || false);
});
$p.N = (function(x, default$1) {
  return (false ? x.b7D : default$1.d(x));
});
var $d_Lmealorama_jsonCodecs$package$$anon$41 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$41, "mealorama.jsonCodecs$package$$anon$41", ({
  K5: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$41 as $d_Lmealorama_jsonCodecs$package$$anon$41 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$41.js.map
